<h1 mat-dialog-title>Cancelar pedido</h1>
<div mat-dialog-content>
  <p>¿Desea cancelar el pedido?</p>
  <p>Recuerde que los costes de envío de documentos de firma</p> <p>serán contabilizados a pesar de que se cancele la solicitud.</p>


</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false">No</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Aceptar</button>
</div>
